import { BsExclamationCircle } from "react-icons/bs";

const DEFAULT_MESSAGE = "This payment method is currently unavailable.";

const NOTICE_STYLES = {
	backgroundColor: "rgba(254, 215, 170, 0.2)",
};

const UnavailableMessageNotice = ({ label, message, compact = true }) => {
	const displayMessage = message?.trim() || DEFAULT_MESSAGE;

	return (
		<div
			className={`flex gap-2 rounded-md border-2 border-red-700 ${compact ? "px-2 py-2" : "px-3 py-2"}`}
			role="note"
			style={NOTICE_STYLES}
		>
			<span className="flex-shrink-0 w-8 h-8 rounded-full bg-amber-200 text-amber-800 flex items-center justify-center mt-0.5">
				<BsExclamationCircle size={40} />
			</span>
			<div className="min-w-0 flex-1">
				{label && (
					<p className="text-sm font-bold text-akgreenest leading-tight">{label} unavailable</p>
				)}
				<p className={`text-xs text-akgreenest leading-snug ${label ? "mt-0.5" : ""}`}>
					{displayMessage}
				</p>
			</div>
		</div>
	);
};

export default UnavailableMessageNotice;
export { DEFAULT_MESSAGE };
